import   React               ,
       { useState            ,
         useEffect           ,
         ChangeEvent         }  from "react";

import   classNames             from "classnames";

import   styles                 from "./Field.module.scss";

import   Calendar               from "./Calendar";

import   Icon                   from "../images/Icon";

import   ModalDialogBox         from "../windows/ModalDialogBox";


import { convertStringToDate }  from '../../../dataTypes/timeManagment/utils';

export interface FieldCalendarProps {
  placeholder?   : string;
  value?         : string;
  autocomplete?  : string;
  readOnly?      : boolean;
  onChange?      : (event: React.ChangeEvent<HTMLInputElement>, value?: string | Date) => void;
  width?         : string;
  height?        : string;
  glowColor?     : string;
  dateFormat?    : string;
  showPreview?   : boolean;
  showHours?     : boolean;
  checkInput?    : boolean;
}

export const FieldCalendar = ({ placeholder                  ,
                        value        = ""            ,
                        autocomplete                 ,
                        readOnly                     ,
                        onChange                     ,
                        width        = "100%"        ,
                        height       = "fit-content" ,
                        glowColor    = "var(--color-Field-Focus-normal)",
                        dateFormat   = "dd/MM/yyyy"  ,
                        showPreview  = true          ,
                        showHours    = true          ,
                        checkInput   = true          }: FieldCalendarProps) => {

  const fieldStyle = { "--glow-color": glowColor } as React.CSSProperties;

  const [ inputValue   , setInputValue   ] = useState(value);
  const [ showCalendar , setShowCalendar ] = useState(false);
  const [ hasFocus     , setHasFocus     ] = useState(false);


  useEffect(() => {

    if (!hasFocus)
     {
      setInputValue(value);
    }
  }, [value, hasFocus]);


  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {

    const input = event.target.value;

    const parsedValue = convertStringToDate(input, dateFormat);

    if ( checkInput )
          {
           if (parsedValue !== null)
            {
             setInputValue(input);

             if (onChange)
              {
               onChange (event, parsedValue as Date);
              }
            }
          }
     else {
           setInputValue(input);

           if (onChange)
            {
             onChange (event);
            }
          }
  };

  const handleDateChange = (date: string) => {

    setInputValue(date);
    setShowCalendar(false);

    if (onChange)
     {
      const fakeEvent = { target: { value: date } } as unknown as ChangeEvent<HTMLInputElement>;

      onChange (fakeEvent, date);
     }
  };

  const renderInput = (): JSX.Element => {

    const textInputProps = {
      className    : classNames(styles.field_input),
      placeholder ,
      value        : inputValue ,
      onChange     : (e: ChangeEvent<HTMLInputElement>) => handleChange(e),
      onFocus      : () => setHasFocus(true),
      onBlur       : () => setHasFocus(false),
    };

    return (
            <div className = { classNames ( styles.field_with_icon ,
                                            styles.field_with_calendar ) } >
              <input {...textInputProps} type="text" />
                <Icon onClick    = {() => setShowCalendar(!showCalendar)}
                      name       = "calendar"
                      color      = "var(--color-Field-Icon-normal)"
                      hoverColor = "var(--color-Field-Icon-hover-normal)" />
            </div>
          );
  };

  return (
    <div className={classNames(styles.field)} style={{ width, height, ...fieldStyle }}>
      {renderInput()}
      <ModalDialogBox isOpen={showCalendar} onClose={() => setShowCalendar(false)}>
        <Calendar onDateClick={handleDateChange} showHourPanel={showHours}/>
      </ModalDialogBox>
    </div>
  );
};

export default FieldCalendar;
